import { useEffect, useState } from 'react';
import { useHistory } from 'react-router-dom';
import { Button, FormGroup, HFlex, Input, Modal, VGrid, useToasts } from 'tombac';
import { useUserDetails } from "../UserDetailsProvider";
import { useChangeEmailMutation } from "../api/userManagementApiHooks";
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
export const EditUserEmailModal = _ref => {
  let {
    isOpen,
    onRequestClose
  } = _ref;
  const {
    addToast
  } = useToasts();
  const user = useUserDetails();
  const history = useHistory();
  const [value, setValue] = useState(user.email);
  useEffect(() => {
    if (isOpen) setValue(user.email);
  }, [isOpen, user.email]);
  const {
    isLoading,
    mutate: changeEmail
  } = useChangeEmailMutation();
  const handleSave = async () => {
    changeEmail({
      currentEmail: user.email,
      newEmail: value
    }, {
      onError: async error => {
        console.error(error);
        const response = await error.json();
        addToast(response.message ? /*#__PURE__*/_jsx("div", {
          style: {
            overflowWrap: 'anywhere',
            paddingRight: '5px'
          },
          children: response.message
        }) : "Could not update user's email.", 'danger');
      },
      onSuccess() {
        addToast("User's email has been changed.", 'success');
        onRequestClose();
        history.replace(`/users/edit/${encodeURIComponent(value)}`);
      }
    });
  };
  return /*#__PURE__*/_jsx(Modal, {
    isOpen: isOpen,
    onRequestClose: onRequestClose,
    "data-sentry-element": "Modal",
    "data-sentry-component": "EditUserEmailModal",
    "data-sentry-source-file": "EditUserEmailModal.tsx",
    children: /*#__PURE__*/_jsxs(VGrid, {
      gap: 3,
      $p: "4sp",
      $pb: "3sp",
      "data-sentry-element": "VGrid",
      "data-sentry-source-file": "EditUserEmailModal.tsx",
      "data-sentry-element": "VGrid",
      children: [/*#__PURE__*/_jsx(FormGroup, {
        $width: "40sp",
        htmlFor: "new-email-input",
        label: "New email",
        "data-sentry-element": "FormGroup",
        "data-sentry-source-file": "EditUserEmailModal.tsx",
        "data-sentry-element": "FormGroup",
        children: /*#__PURE__*/_jsx(Input, {
          id: "new-email-input",
          onChange: e => setValue(e.target.value),
          value: value,
          "data-sentry-element": "Input",
          "data-sentry-source-file": "EditUserEmailModal.tsx",
          "data-sentry-element": "Input"
        })
      }), /*#__PURE__*/_jsxs(HFlex, {
        "data-sentry-element": "HFlex",
        "data-sentry-source-file": "EditUserEmailModal.tsx",
        "data-sentry-element": "HFlex",
        children: [/*#__PURE__*/_jsx(Button, {
          $ml: "auto",
          onClick: () => onRequestClose(),
          variant: "flat",
          "data-sentry-element": "Button",
          "data-sentry-source-file": "EditUserEmailModal.tsx",
          "data-sentry-element": "Button",
          children: "Cancel"
        }), /*#__PURE__*/_jsx(Button, {
          busy: isLoading,
          $ml: "1sp",
          onClick: handleSave,
          variant: "primary",
          "data-sentry-element": "Button",
          "data-sentry-source-file": "EditUserEmailModal.tsx",
          "data-sentry-element": "Button",
          children: "Save"
        })]
      })]
    })
  });
};